// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getSizeRequest: ['data'],
  getSizeSuccess: ['data'],
  getSizeFailure: ['err'],

  getAllSizeRequest: ['data'],
  getAllSizeSuccess: ['data'],
  getAllSizeFailure: ['err'],

  createSizeRequest: ['data'],
  createSizeSuccess: ['data'],
  createSizeFailure: ['err'],

  updateSizeRequest: ['data'],
  updateSizeSuccess: ['data'],
  updateSizeFailure: ['err'],

  deleteSizeRequest: ['data'],
  deleteSizeSuccess: ['data'],
  deleteSizeFailure: ['err']

})

export const SizeTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  dataAll: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: null
  })

export const successAll = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    dataAll: data,
    err: null,
    success: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_SIZE_SUCCESS]: success,
  [Types.GET_SIZE_REQUEST]: request,
  [Types.GET_SIZE_FAILURE]: failure,

  [Types.GET_ALL_SIZE_SUCCESS]: successAll,
  [Types.GET_ALL_SIZE_REQUEST]: request,
  [Types.GET_ALL_SIZE_FAILURE]: failure,

  [Types.CREATE_SIZE_SUCCESS]: success,
  [Types.CREATE_SIZE_REQUEST]: request,
  [Types.CREATE_SIZE_FAILURE]: failure,

  [Types.UPDATE_SIZE_SUCCESS]: manipulateSuccess,
  [Types.UPDATE_SIZE_REQUEST]: manipulateRequest,
  [Types.UPDATE_SIZE_FAILURE]: manipulateFailure,

  [Types.DELETE_SIZE_SUCCESS]: manipulateSuccess,
  [Types.DELETE_SIZE_REQUEST]: manipulateRequest,
  [Types.DELETE_SIZE_FAILURE]: manipulateFailure
})



// WEBPACK FOOTER //
// ./src/Redux/SizeRedux.js